document.addEventListener('DOMContentLoaded', () => {
  const discountContainer = document.querySelector('.cart-discount__codes');

  if (!discountContainer) return;

  // Watch for discount code being added to the DOM
  const observer = new MutationObserver(() => {
    const pill = discountContainer.querySelector('.cart-discount__pill');
    if (!pill) return;

    const code = pill.getAttribute('data-discount-code')?.trim();
    if (!code) return;

    showDiscountPopup(code);
  });

  observer.observe(discountContainer, { childList: true });

  function showDiscountPopup(code) {
    // Messages for different codes
    const messages = {
      "ICCA MEMBER": "ICCA MEMBER discount applied. We will confirm eligibility. Thanks!",
      "Subscribed Member": "Subscribed Member discount applied. It’s directly applied.",
    };

    const message = messages[code] || `${code} discount applied successfully.`;

    // Create the popup
    const popup = document.createElement('div');
    popup.className = "discount-popup-overlay";
    popup.innerHTML = `
      <div class="discount-popup-box">
        <p>${message}</p>
        <button class="discount-popup-close">OK</button>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.discount-popup-close').addEventListener('click', () => {
      popup.remove();
    });
  }
});
